import { render, staticRenderFns } from "./selectIcon.vue?vue&type=template&id=54e12f86&scoped=true"
import script from "./selectIcon.vue?vue&type=script&lang=js"
export * from "./selectIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54e12f86",
  null
  
)

export default component.exports